import type { FormAction } from "src/components/Form/Form.types.ts";
import { createModuleI18nNamespaces } from "src/system/createModuleI18nNamespaces.ts";
import { getResourceI18nNamespace } from "src/system/getResourceI18nNamespace.ts";
type FormTranslationProps = {
  type: "form";
  formType: FormAction;
  tab?: string;
};
type ListTranslationProps = {
  type: "list";
};
type LayoutTranslationProps = {
  type: "layout";
};

type ResourceTranslationProps = {
  type: "resource";
};

type CommonProps = {
  resource: string;
};

export type GetErpTranslationNamespaceProps = CommonProps &
  (
    | FormTranslationProps
    | ListTranslationProps
    | LayoutTranslationProps
    | ResourceTranslationProps
  );

export const getErpTranslationNamespace = (
  props: GetErpTranslationNamespaceProps,
) => {
  const { resource } = props;
  const namespaces = createModuleI18nNamespaces();
  if (props.type === "form") {
    return namespaces.form({
      type: props.formType,
      tab: props.tab,
      resource,
    });
  }
  if (props.type === "layout") {
    return namespaces.layout(resource);
  }
  if (props.type === "resource") {
    return getResourceI18nNamespace(resource);
  }
  return namespaces.list(resource);
};
